export var AiringType;
(function (AiringType) {
    AiringType["Archived"] = "archived";
    AiringType["ComingSoon"] = "coming_soon";
    AiringType["OnAir"] = "on_air";
})(AiringType || (AiringType = {}));
export var Channel;
(function (Channel) {
    Channel["Vtm"] = "VTM";
    Channel["Vtm2"] = "VTM2";
    Channel["Vtm3"] = "VTM3";
    Channel["Vtm4"] = "VTM4";
    Channel["Vtmgoexclusives"] = "VTMGOEXCLUSIVES";
    Channel["News"] = "NEWS";
})(Channel || (Channel = {}));
export var DisplayMode;
(function (DisplayMode) {
    DisplayMode["Content"] = "Content";
    DisplayMode["Fullscreen"] = "Fullscreen";
    DisplayMode["Slot"] = "Slot";
})(DisplayMode || (DisplayMode = {}));
export var EmbedType;
(function (EmbedType) {
    EmbedType["IFrame"] = "IFrame";
    EmbedType["Qualifio"] = "Qualifio";
    EmbedType["Spotify"] = "Spotify";
})(EmbedType || (EmbedType = {}));
export var EntityType;
(function (EntityType) {
    EntityType["Article"] = "Article";
    EntityType["BasicPage"] = "BasicPage";
    EntityType["Contest"] = "Contest";
    EntityType["CustomDynamicHero"] = "CustomDynamicHero";
    EntityType["GeneralManualCollection"] = "GeneralManualCollection";
    EntityType["HomePage"] = "HomePage";
    EntityType["Interactive"] = "Interactive";
    EntityType["Participate"] = "Participate";
    EntityType["Person"] = "Person";
    EntityType["Program"] = "Program";
    EntityType["ProgramDynamicHero"] = "ProgramDynamicHero";
    EntityType["Team"] = "Team";
    EntityType["TicketOverview"] = "TicketOverview";
    EntityType["Video"] = "Video";
})(EntityType || (EntityType = {}));
export var EntityTypeWithProgram;
(function (EntityTypeWithProgram) {
    EntityTypeWithProgram["Article"] = "Article";
    EntityTypeWithProgram["BasicPage"] = "BasicPage";
    EntityTypeWithProgram["Contest"] = "Contest";
    EntityTypeWithProgram["Interactive"] = "Interactive";
    EntityTypeWithProgram["Participate"] = "Participate";
    EntityTypeWithProgram["Person"] = "Person";
    EntityTypeWithProgram["Team"] = "Team";
    EntityTypeWithProgram["Video"] = "Video";
})(EntityTypeWithProgram || (EntityTypeWithProgram = {}));
export var HomePageBannerType;
(function (HomePageBannerType) {
    HomePageBannerType["Cpbd"] = "CPBD";
    HomePageBannerType["DefaultVtmGo"] = "DEFAULT_VTM_GO";
    HomePageBannerType["DefaultVtmGoPlus"] = "DEFAULT_VTM_GO_PLUS";
    HomePageBannerType["News"] = "NEWS";
    HomePageBannerType["Vtm"] = "VTM";
    HomePageBannerType["VtmGo"] = "VTM_GO";
    HomePageBannerType["VtmGoPlus"] = "VTM_GO_PLUS";
})(HomePageBannerType || (HomePageBannerType = {}));
export var HomePageHighlightType;
(function (HomePageHighlightType) {
    HomePageHighlightType["Condensed"] = "Condensed";
    HomePageHighlightType["Promoted"] = "Promoted";
})(HomePageHighlightType || (HomePageHighlightType = {}));
export var InteractiveCategory;
(function (InteractiveCategory) {
    InteractiveCategory["Game"] = "game";
    InteractiveCategory["Other"] = "other";
    InteractiveCategory["SecondScreen"] = "second_screen";
    InteractiveCategory["Ticket"] = "ticket";
    InteractiveCategory["Voting"] = "voting";
})(InteractiveCategory || (InteractiveCategory = {}));
export var LinkTarget;
(function (LinkTarget) {
    LinkTarget["Blank"] = "_blank";
    LinkTarget["Self"] = "_self";
})(LinkTarget || (LinkTarget = {}));
export var LinkType;
(function (LinkType) {
    LinkType["Program"] = "program";
    LinkType["TvGuide"] = "tvGuide";
    LinkType["VtmGo"] = "vtmGo";
})(LinkType || (LinkType = {}));
export var ProgramOverviewCategory;
(function (ProgramOverviewCategory) {
    ProgramOverviewCategory["Movies"] = "movies";
    ProgramOverviewCategory["NewsAndActua"] = "newsAndActua";
    ProgramOverviewCategory["Reality"] = "reality";
    ProgramOverviewCategory["Series"] = "series";
    ProgramOverviewCategory["ShowsAndGames"] = "showsAndGames";
    ProgramOverviewCategory["Sports"] = "sports";
    ProgramOverviewCategory["Youth"] = "youth";
})(ProgramOverviewCategory || (ProgramOverviewCategory = {}));
export var SearchResultType;
(function (SearchResultType) {
    SearchResultType["Program"] = "Program";
})(SearchResultType || (SearchResultType = {}));
export var SpotifyType;
(function (SpotifyType) {
    SpotifyType["Album"] = "Album";
    SpotifyType["Episode"] = "Episode";
    SpotifyType["Playlist"] = "Playlist";
    SpotifyType["Show"] = "Show";
    SpotifyType["Track"] = "Track";
})(SpotifyType || (SpotifyType = {}));
export var TicketTag;
(function (TicketTag) {
    TicketTag["Spotlight"] = "spotlight";
})(TicketTag || (TicketTag = {}));
